module.exports = __webpack_public_path__ + "img/rightGreen.7e89fb3d.svg";